function generateVerifier(): string {
  let array = new Uint8Array(32);
  array = globalThis.crypto.getRandomValues(array);
  return String.fromCharCode.apply(null, Array.from(array));
}

function base64URLEncode(str: string): string {
  const b64 = btoa(str);
  const encoded = b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  return encoded;
}

const sha256 = async (str: string): Promise<string> => {
  const hashArray = await window.crypto.subtle.digest({name: "SHA-256"}, new TextEncoder().encode(str));
  const uIntArray = new Uint8Array(hashArray);
  const numberArray = Array.from(uIntArray);
  const hashString = String.fromCharCode.apply(null, numberArray);
  return base64URLEncode(hashString);
};

export const prepareFirstPKCEStep = async (): Promise<string> => {
  const verifier = generateVerifier();
  localStorage.setItem("verifier", JSON.stringify({verifier}));
  const code = await sha256(verifier);
  return code;
};

export const retrieveVerifier = (): string | null => {
  const item = localStorage.getItem("verifier");
  if (!item) {
    return null;
  }
  const {verifier} = JSON.parse(item);
  return verifier;
};

export const clearVerifier = (): void => {
  localStorage.removeItem("verifier");
};
